import React, { FC } from 'react';
import { Box, BoxProps } from '@mantine/core';

const Block: FC<
    {
        id?: string;
        size: 'sm' | 'md' | 'lg' | 'xl' | number;
        children: React.ReactNode;
    } & BoxProps
> = ({ id, size, children, ...props }) => {
    const maxWidth =
        {
            sm: 640,
            md: 768,
            lg: 1080,
            xl: 1280,
        }[size] || size;

    return (
        <Box id={id} w="100%" mx="auto" {...props} style={{ maxWidth, ...(props.style ?? {}) }}>
            {children}
        </Box>
    );
};

export { Block };
